import React from 'react';

import './ArticleAuthor.scss';
import { link } from '../../helpers/link';
import icons from '../../shared/assets/icons';
import { getString } from '../../helpers/styles';

const { Subscribe } = icons;

export default function ArticleAuthor(props) {
  const { user, author, config, subscribeChannel, unsubscribeChannel } = props;

  const uri = author.link.split('/').pop();

  const isSubscribed =
    user.username &&
    user.channelSubscriptions.find((item) => item.channel.uri === uri);

  return link(
    <section id="article_author">
      <div id="article_author_image">
        <img alt="article-author-image" src={author.imageUrl} />
      </div>

      <div id="article_author_data">
        <p>{author.displayName}</p>

        <span>{author.description}</span>

        <div
          id="article_author_subscribe_button"
          onClick={(e) => (isSubscribed ? unsubscribe(e) : subscribe(e))}
          className={getString('article_author_subscribed', isSubscribed)}
        >
          <Subscribe />
          <p>{isSubscribed ? 'Geabonneerd' : 'Abonneer'}</p>
        </div>
      </div>
    </section>,
    `/channels/${author.link}`
  );

  function subscribe(e) {
    e.preventDefault();

    if (!props.user.username) return (location.href = config.LOGIN_URL);

    subscribeChannel({
      variables: {
        channelUri: uri
      }
    });
  }

  function unsubscribe(e) {
    e.preventDefault();

    unsubscribeChannel({
      variables: {
        channelUri: uri
      }
    });
  }
}
